
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/canvas/[slug]",
      function () {
        return require("private-next-pages/canvas/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/canvas/[slug]"])
      });
    }
  